import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Modal, Button } from 'controls'
import styles from './styles'

class ConfirmationDialog extends PureComponent {
  static propTypes = {
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
  }

  render() {
    return (
      <Modal isOpen={this.props.isOpen} showCloseButton={false}>
        {this.props.children}
        <div className="confirmation-buttons">
          <Button
            color="primary"
            outline
            onClick={this.props.onCancel}
          >
            Cancelar
          </Button>
          <Button
            color="primary"
            onClick={this.props.onConfirm}
          >
            Aceptar
          </Button>
          <style jsx>{styles}</style>
        </div>
      </Modal>
    )
  }
}

export default ConfirmationDialog
